module.exports = __webpack_public_path__ + "374bd399d305f8bff3dcdd3a2015855f.MP3";